import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { GoogleLogin } from '@react-oauth/google';

/**
 * AdminRoute — blocks access unless the signed-in user is an admin.
 * Shows a Google sign-in if not logged in, or an "Access Denied" screen
 * if logged in but not an admin (alvarezjd404@gmail.com).
 */
export default function AdminRoute({ children }) {
  const { user, loading, handleGoogleSuccess } = useAuth();

  if (loading) {
    return (
      <div className="signin-gate">
        <div className="signin-loading">Loading…</div>
      </div>
    );
  }

  // Not logged in — show sign-in
  if (!user) {
    return (
      <div className="signin-gate">
        <div className="signin-card">
          <img src="/logo.png" alt="Vector Labs" className="signin-logo-img" />
          <h2>Admin Access Required</h2>
          <p>Sign in with an authorized admin account to continue.</p>
          <div className="google-btn-wrapper">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={() => console.error('Google Sign-In failed')}
              theme="outline"
              size="large"
              text="signin_with"
              shape="rectangular"
              width="300"
            />
          </div>
        </div>
      </div>
    );
  }

  // Logged in but NOT admin — redirect to home
  if (!user.isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
